
import {defineComponent} from "vue";
import {CatalogProductsRestService} from "@/services/rest/cpc-mgmt/CatalogProductsRestService";
import BaseCardBody from "@/components/UI/Bootstrap/Card/BaseCardBody.vue";
import BaseCardHeader from "@/components/UI/Bootstrap/Card/BaseCardHeader.vue";
import BaseCard from "@/components/UI/Bootstrap/Card/BaseCard.vue";
import InputNumber from "@/components/UI/InputNumber.vue";
import {MaximumOrderQuantityRestDtoModel} from "@/models/api/pharma-cpc-product-mgmt/MaximumOrderQuantityRestDtoModel";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {FormMixin} from "@/components/base/FormMixin";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {MaximumOrderQuantityRestDto} from "@/api/pharma-cpc-product-mgmt/models";

export default defineComponent({
  name: "ProductDetailMaximumOrderQuantity",
  mixins: [FormMixin],
  components: {BaseDeleteButton, GenericFormWrapper, InputNumber, BaseCard, BaseCardHeader, BaseCardBody},
  props: {
    productCode: {
      type: String,
      required: true
    }
  },
  data: () => ({
    maxQuantity: MaximumOrderQuantityRestDtoModel.createWithDefaults() as MaximumOrderQuantityRestDto,
  }),
  mounted() {
    this.reloadContent();
  },
  methods: {
    async doReload(): Promise<void> {
      if (this.productCode) {
        this.maxQuantity =
          await CatalogProductsRestService.getInstance().findProductCustomerMaximumOrderQuantity(this.productCode);
      }
    },
    async doSubmit(): Promise<void> {
      if (this.maxQuantity.max_per_order) {
        await CatalogProductsRestService.getInstance().syncProductCustomerMaximumOrderQuantity(
          this.productCode,
          new MaximumOrderQuantityRestDtoModel(this.maxQuantity.max_per_order)
        );
      }
    },
    async doDelete(): Promise<void> {
      await CatalogProductsRestService.getInstance().deleteProductCustomerMaximumOrderQuantity(this.productCode);
    },
  },
});
